/**
 * Nhận diện lỗi nghiệp vụ của SP-005 từ lỗi axios ném ra.
 *
 * 🔴 Sai mật khẩu đăng nhập là **HTTP 400**, không phải 401 (BE contract §3.3, cạm bẫy #2).
 * `src/services/Axios.js` có interceptor bắt 401 là xoá token + tải lại trang — map nhầm lỗi này
 * thành 401 sẽ đá người dùng ra khỏi hệ thống giữa chừng.
 *
 * 🔴 Nhận biết chỉ bằng TIỀN TỐ mã `E10139`, không so cả câu (câu tiếng Anh có thể đổi), và
 * không suy từ "message là chuỗi" — lỗi uuid sai định dạng cũng là 400 với message chuỗi.
 */

interface HttpErrorShape {
  response?: { status?: number; data?: { message?: string | string[] } }
}

const asHttpError = (error: unknown): HttpErrorShape => (
  typeof error === 'object' && error !== null ? (error as HttpErrorShape) : {}
)

const statusOf = (error: unknown): number | undefined => asHttpError(error).response?.status

const messageOf = (error: unknown): string | string[] | undefined => asHttpError(error).response?.data?.message

/** Mã lỗi nghiệp vụ của BE — `E10139: The current password is incorrect`. */
const WRONG_PASSWORD_CODE = 'E10139'

export const isWrongLoginPasswordError = (error: unknown): boolean => {
  if (statusOf(error) !== 400) return false
  const message = messageOf(error)
  return typeof message === 'string' && message.startsWith(WRONG_PASSWORD_CODE)
}

/** Bản ghi không còn (đã bị xoá ở nơi khác) — `E10151`. Nơi gọi phải làm mới danh sách. */
export const isNotFoundError = (error: unknown): boolean => statusOf(error) === 404

/**
 * Không đủ quyền. Hai dạng message (`E10152` chặn ở BE, `You cannot be granted!!!` chặn ở
 * gateway) — rẽ nhánh theo HTTP status, KHÔNG so message (cạm bẫy #3).
 */
export const isForbiddenError = (error: unknown): boolean => statusOf(error) === 403
